import { FormInput, SelectInput } from '@policoders/ds';

import { ICashBookFormProps, useCashBookForm } from './cash-book-form.hook';

const CashBookForm = ({ data, onChange }: ICashBookFormProps) => {
  const { state, transactionTypes, handleChange } = useCashBookForm({
    data,
    onChange,
  });

  return (
    <div>
      <div className="row">
        <div className="col-12 col-sm-4 col-lg-4">
          <SelectInput
            label="Tipo lançamento"
            field="transactionType"
            value={state.transactionType}
            options={transactionTypes()}
            onChange={handleChange}
          />
        </div>
        <div className="col-6 col-sm-4 col-lg-4">
          <FormInput
            type="date"
            label="Data"
            field="date"
            value={state.date}
            onChange={handleChange}
          />
        </div>
        <div className="col-6 col-sm-4 col-lg-4">
          <FormInput
            type="number"
            label="Valor"
            field="amount"
            value={state.amount}
            onChange={handleChange}
          />
        </div>
        <div className="col-12">
          <FormInput
            type="textarea"
            label="Descrição"
            field="notes"
            value={state.notes}
            onTextAreaChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CashBookForm;
